import axios from "axios";
import { Filiale } from "../../interface/Filiale";
import ReactQueryInstance from "../../utility_objects/ReactQueryInstance";

const mapListaFiliali = (filiale: Filiale) => {
  let newFiliale: Filiale = filiale;

  switch (filiale.tipo) {
    case "A":
      newFiliale.tipoString = "Sede";
      break;
    case "B":
      newFiliale.tipoString = "Negozio";
      break;
    case "C":
      newFiliale.tipoString = "Laboratorio";
      break;
    case "D":
      newFiliale.tipoString = "Controllore";
      break;
  }

  let nome = filiale.nome;
  let codiceInterno = filiale.codiceInterno;
  let result = "00";
  if (nome && codiceInterno) result = `${nome} - ${codiceInterno}`;
  else {
    if (nome) result = nome;
    if (codiceInterno) result = codiceInterno;
  }

  newFiliale.nomeAndCodiceInterno = result;

  return newFiliale;
};

export const fetchListaFiliali = () => {
  return new Promise<Filiale[]>((resolve, reject) => {
    let listaFilialiSaved: Filiale[] = ReactQueryInstance.getQueryData([
      "listafiliali",
    ]);
    if (listaFilialiSaved) {
      resolve(listaFilialiSaved);
    } else {
      axios
        .get("/focusapi/magazzino/getlistafiliali", {
          params: {
            _dc: new Date().getTime(),
          },
        })
        .then((response) => {
          let listaFiliali = response.data.data;
          const success = response.data.success;

          if (success) {
            listaFiliali.map(mapListaFiliali);

            ReactQueryInstance.setQueryData(["listafiliali"], listaFiliali);
            resolve(listaFiliali);
          } else {
            reject();
          }
        })
        .catch(() => {
          reject();
        });
    }
  });
};
